<template src="./organization-management.html"></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage'
import tabulatorMixin from '@/mixins/tabulator'
import Tabulator from '@/components/tabulator/Tabulator'

export default {
  components: {
    ContextPage,
    Tabulator
  },
  mixins: [tabulatorMixin],
  data () {
    return {
      data: [],
      RegistrationStatus: {
        PENDING: 1,
        APPROVED: 2,
        CANCELLED: 3
      },
      help: {
        list: Vue.$helpConfig.organizationList
      },
      loader: false,
      loading: false,
      pageLoader: false,
      tabulatorOptions: {
        ajaxURL: Vue.$config.api_root + '/' + Vue.$apiConfig.pagedOrganizationsGet,
        columns: [
          {
            title: this.$t('organizationAdministration.budgetUserId'),
            field: 'id',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'center'
          },
          {
            title: this.$t('organizationAdministration.name'),
            field: 'name',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'center'
          },
          {
            title: this.$t('organizationAdministration.adminName'),
            field: 'adminName',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'center'
          },
          {
            title: this.$t('organizationAdministration.registrationDate'),
            hozAlign: 'center',
            field: 'createdDate',
            sorter: 'date',
            formatter: (cell, formatterParams, onRendered) => {
              return cell.getValue() ? this.formatShortDate(cell.getValue()) : this.$t('general.undefined')
            },
            headerFilter: this.vDateRange,
            headerFilterParams: { isRange: true },
            headerFilterLiveFilter: false
          },
          {
            title: this.$t('organizationAdministration.status'),
            hozAlign: 'center',
            field: 'status',
            headerFilter: this.vTextSelect,
            headerFilterLiveFilter: false,
            formatter: (cell) => {
              const status = cell.getValue()
              if (status === this.RegistrationStatus.APPROVED) {
                return this.successLabel(this.$t('organizationAdministration.statuses.' + status))
              } else if (status === this.RegistrationStatus.CANCELLED) {
                return this.errorLabel(this.$t('organizationAdministration.statuses.' + status))
              }

              return this.inactiveLabel(this.$t('organizationAdministration.statuses.' + status))
            },
            headerFilterParams: {
              values: [
                { text: this.$t('organizationAdministration.statuses.1'), value: 1 },
                { text: this.$t('organizationAdministration.statuses.2'), value: 2 },
                { text: this.$t('organizationAdministration.statuses.3'), value: 3 }
              ]
            }
          }
        ],
        rowClick: (e, row) => {
          const administrationURL = '/administration/organization/' + row.getData().id
          this.handleRowClickNavigation(e, administrationURL)
        }
      }
    }
  }
}
</script>
<style>
.status-active-span {
   background-color: var(--v-success-base);
   color: #fff;
   border-radius: 2px;
   padding: 8px 24px;
   font-size: 12px;
 }

.status-inactive-span {
   background-color: var(--v-pending-base);
   color: #fff;
   border-radius: 2px;
   padding: 8px 24px;
   font-size: 12px;
 }

.status-revoked-span {
   background-color: var(--v-error-base);
   color: #fff;
   border-radius: 2px;
   padding: 8px 24px;
   font-size: 12px;
 }

</style>
